import { render, staticRenderFns } from "./BuyerCampaignSettings.vue?vue&type=template&id=f7ab8dce&scoped=true&lang=true"
import script from "./BuyerCampaignSettings.vue?vue&type=script&lang=js"
export * from "./BuyerCampaignSettings.vue?vue&type=script&lang=js"
import style0 from "./BuyerCampaignSettings.vue?vue&type=style&index=0&id=f7ab8dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ab8dce",
  null
  
)

export default component.exports